import * as React from "react"

const ArrowDown = ({size}) => (
  <svg width={size || 14} height={size || 8} viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2.5.4 7 4.9 11.5.4l1.8.9L7 7.6.7 1.3 2.5.4Z" fill="currentColor" />
  </svg>
)

export default ArrowDown
